export default __webpack_public_path__ + "static/media/DAIF_Services_Screen5_in-end.b5fe9ec5.jpg";